import './styles.css';

import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import Footer from '../../components/footer';
import Loading from '../../components/loading/Loading';
import Navbar from '../../components/navbar';
import axiosInstance from '../../api/axiosConfig';
import { message } from 'antd';
import { utils } from '../../utils';

const BlogPostPage = () => {
    const { state } = useLocation();
    const { id } = useParams(); // Get ID from URL
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        const fetchBlog = async () => {
            if (!state && id) {
                try {
                    const response = await axiosInstance.get(`articles/${id}`);
                    setBlog(response.data);
                } catch (error) {
                    message.error("An unexpected error has occurred. Try again later.")
                }
            }
        };

        fetchBlog();
    }, [state, id]);

    const data = state || blog;

    if (!data) {
        return (
            <>
                <Navbar />
                <Loading message={"Working on it"} />
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="blog-post-container">
                <div className="blog-post-details">
                    <h1 className="blog-post-title">{data.title}</h1>
                    <p className="blog-post-author">
                        {data.author} | {utils.formatDateTime(data.date).formattedDate} at {utils.formatDateTime(data.date).formattedTime}
                    </p>
                </div>
                <div className="blog-post-content">
                    <img src={data.imageUrl} alt="Blog" />
                    <div dangerouslySetInnerHTML={{ __html: data.content }} />
                    <br />
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BlogPostPage;
